import { ScreenReaderOnly } from './ScreenReaderOnly';
/**
 * Use this when you need to have different text for screen readers and visible text.
 * And the element does not have a role. eg just a span or div.
 */
export function ScreenReaderLabel({ srText, visibleText }) {
    return (<>
      <ScreenReaderOnly>{srText}</ScreenReaderOnly>
      <span aria-hidden>{visibleText}</span>
    </>);
}
